import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Notistack } from '../Notistack'
const SUCCESS_MESSAGE = 'Текст скопирован'

export const CopyText = ({ text }) => {
    const [openSnackbar, setOpenSnackbar] = React.useState(false)

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    return (
        <>
            <CopyToClipboard text={text} onCopy={() => setOpenSnackbar(true)}>
                <MenuItem>
                    <ListItemText
                        primary={<Typography variant="body">Копировать текст</Typography>}
                    />
                    <ContentCopyOutlinedIcon fontSize="small" sx={{ marginRight: 'auto' }} />
                </MenuItem>
            </CopyToClipboard>

            <Notistack
                open={openSnackbar}
                isError={false}
                message={SUCCESS_MESSAGE}
                onClose={handleCloseSnackbar}
            />
        </>
    )
}
